module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/full-print/1-5c80fb6ee33ab151c0dec200be464f34.jpg";